import { type NoticeResponseItem, NoticeResponseItemSchema, NoticeResponseItemsSchema } from './notices-api-types'
import {
  type AlarmSettingsResponse,
  AlarmSettingsResponseSchema,
  type CheckUserResponsePayload,
  CheckUserResponseSchema
} from './company-api-types'
import {
  type AdminDeviceForProvisionCsvImportResponse,
  AdminDeviceForProvisionCsvImportResponseSchema,
  type AdminDeviceProfileResponseItem,
  AdminDeviceProfilesResponse,
  type AdminDeviceProvisionsResponseItem,
  AdminDeviceProvisionsResponseItemSchema,
  AdminDeviceProvisionsResponseSchema,
  type AdminTenantResponseItem,
  AdminTenantsResponse
} from './admin-device-provisions-api-types'
import {
  AdminCompaniesResponseSchema,
  type AdminCompanyIntegrationResponse,
  AdminCompanyIntegrationResponseSchema,
  type AdminCompanyResponse,
  AdminCompanyResponseSchema,
  type AdminCompanyUserResponse,
  AdminCompanyUserResponseSchema,
  AdminCompanyUsersResponseSchema,
  type UnassignedUserResponseItem,
  UnassignedUserResponseItemsResponseSchema
} from './admin-companies-api-types'
import {
  type DeviceMeterDataHistoryResponseItem,
  DeviceMeterDataHistoryResponseItemsSchema,
  type DeviceResponseItem,
  DeviceResponseItemSchema,
  DeviceResponseItemsSchema
} from './device-api-types'

/* Admin Companies API */

/**
 * Map response of e.g. 'api/admin/companies/' (POST).
 * @param res response payload.
 */
export function mapAdminCompanyResponse(res: unknown): AdminCompanyResponse {
  return AdminCompanyResponseSchema.parse(res)
}

/**
 * Map response of e.g. 'api/admin/companies/' (GET).
 * @param res response payload.
 */
export function mapAdminCompaniesResponse(res: unknown): AdminCompanyResponse[] {
  return AdminCompaniesResponseSchema.parse(res)
}

/**
 * Map response of e.g. 'api/admin/companies/{id}/integration' (GET).
 * @param res response payload.
 */
export function mapAdminCompanyIntegrationResponse(res: unknown): AdminCompanyIntegrationResponse {
  return AdminCompanyIntegrationResponseSchema.parse(res)
}

/**
 * Map response of e.g. 'api/admin/companies/{id}/users' (POST).
 * @param res response payload.
 */
export function mapAdminCompanyUserResponse(res: unknown): AdminCompanyUserResponse {
  return AdminCompanyUserResponseSchema.parse(res)
}

/**
 * Map response of e.g. 'api/admin/companies/{id}/users' (POST).
 * @param res response payload.
 */
export function mapAdminCompanyUsersResponse(res: unknown): AdminCompanyUserResponse[] {
  return AdminCompanyUsersResponseSchema.parse(res)
}

/**
 * Map response of e.g. 'api/admin/companies/unassigned_users' (GET).
 * @param res response payload.
 */
export function mapAdminUnassignedUsersResponse(res: unknown): UnassignedUserResponseItem[] {
  return UnassignedUserResponseItemsResponseSchema.parse(res)
}

/* Admin Devices For Provision API */

/**
 * Map response of e.g. 'api/admin/deviceProvisions/profiles' (GET).
 * @param res response payload.
 */
export function mapAdminDeviceProfilesResponse(res: unknown): AdminDeviceProfileResponseItem[] {
  return AdminDeviceProfilesResponse.parse(res)
}

/**
 * Map response of e.g. 'api/admin/deviceProvisions/tenants' (GET).
 * @param res response payload.
 */
export function mapAdminTenantsResponse(res: unknown): AdminTenantResponseItem[] {
  return AdminTenantsResponse.parse(res)
}

/**
 * Map response of e.g. 'api/admin/deviceProvisions' (GET).
 * @param res response payload.
 */
export function mapAdminDevicesForProvisionResponse(res: unknown): AdminDeviceProvisionsResponseItem[] {
  return AdminDeviceProvisionsResponseSchema.parse(res)
}

/**
 * Map response of e.g. 'api/admin/deviceProvisions' (POST).
 * @param res response payload.
 */
export function mapAdminDeviceForProvisionResponseItem(res: unknown): AdminDeviceProvisionsResponseItem {
  return AdminDeviceProvisionsResponseItemSchema.parse(res)
}

/**
 * Map response of e.g. 'api/admin/deviceProvisions/import' (POST).
 * @param res response payload.
 */
export function mapAdminDeviceForProvisionCsvImportResponse(res: unknown): AdminDeviceForProvisionCsvImportResponse {
  return AdminDeviceForProvisionCsvImportResponseSchema.parse(res)
}

/* Companies - API */

/**
 * Map response of e.g. 'api/company/alarm_settings' (GET).
 * @param res response payload.
 */
export function mapAlarmSettingsResponse(res: unknown): AlarmSettingsResponse {
  return AlarmSettingsResponseSchema.parse(res)
}

/**
 * Map response of e.g. 'api/company/checkUser' (POST).
 * @param res response payload.
 */
export function mapCheckUserResponse(res: unknown): CheckUserResponsePayload {
  return CheckUserResponseSchema.parse(res)
}

/* Device - API */

/**
 * Map response of e.g. 'api/device/{id}/history' (GET).
 * @param res response payload.
 */
export function mapDeviceMeterDataHistoryResponseItems(res: unknown): DeviceMeterDataHistoryResponseItem[] {
  return DeviceMeterDataHistoryResponseItemsSchema.parse(res)
}

/**
 * Map response of e.g. 'api/device/{deviceId}' (PATCH).
 * @param res response payload.
 */
export function mapDeviceResponseItem(res: unknown): DeviceResponseItem {
  return DeviceResponseItemSchema.parse(res)
}

/**
 * Map response of e.g. 'api/device' (GET).
 * @param res response payload.
 */
export function mapDeviceResponseItems(res: unknown): DeviceResponseItem[] {
  return DeviceResponseItemsSchema.parse(res)
}

/* Notices - API */

/**
 * Map response of e.g. 'api/notice' (POST).
 * @param res response payload.
 */
export function mapNoticeResponse(res: unknown): NoticeResponseItem {
  return NoticeResponseItemSchema.parse(res)
}

/**
 * Map response of e.g. 'api/notice' (GET).
 * @param res response payload.
 */
export function mapNoticesResponse(res: unknown): NoticeResponseItem[] {
  return NoticeResponseItemsSchema.parse(res)
}
